import { Component } from '@angular/core';
import { ApiServiceService } from '../../services/api-service.service';

import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment.development';
import { LoaderService } from '../../services/loader.service';

@Component({
  selector: 'app-my-wishlist',
  templateUrl: './my-wishlist.component.html',
  styleUrl: './my-wishlist.component.scss'
})
export class MyWishlistComponent {
  wishListProduct: any;
  product_id : any;
  myWishListImageUrl = environment.ImageBaseUrl;

  sortedProducts: any[] = [];
  sortOrder: string = 'lowToHigh'; // Default sorting order

constructor(private api:ApiServiceService , private toastr:ToastrService , private router:Router ,private Loader:LoaderService){}
 
  ngOnInit(){

  this.getWishlist();
  //  this.addToCart();
  //  this.removeWishlist(productId);
 }
 

 getWishlist() {
this.Loader.showLoader();
  this.api.getWishlist().subscribe({
    next: (res: any) => {
      this.Loader.hideLoader();
      this.wishListProduct = res.data.map((item: any) => ({
        ...item,
        seller_id: item?.product_id?.seller || null, // Ensure product_id is present
      }));
      this.sortedProducts = [...this.wishListProduct];
      this.sortProducts();
    },
    error: (err) => {
      console.error('Error fetching wishlist:', err);
      this.Loader.hideLoader();
    }
  });
}


sortProducts() {
  if (this.sortOrder === 'lowToHigh') {
    this.wishListProduct = [...this.sortedProducts].sort((a, b) => a.product_id.priceInventoryShippingInfo.sellingPrice - b.product_id.priceInventoryShippingInfo.sellingPrice);
  } else if (this.sortOrder === 'highToLow') {
    this.wishListProduct = [...this.sortedProducts].sort((a, b) => b.product_id.priceInventoryShippingInfo.sellingPrice - a.product_id.priceInventoryShippingInfo.sellingPrice);
  }
}

onSortOrderChange(event: any) {
  this.sortOrder = event.target.value;
  this.sortProducts();
}
removeWishlist(productId: any) {

  this.api.removeWishlist(productId).subscribe({
    next: (res: any) => {
      if (res.success) {
        this.toastr.success(res.message);
        this.getWishlist();
      } else {
        this.toastr.error(res.message);
      }
    },
    error: (error) => {
      console.error('Error removing from wishlist:', error);
      this.toastr.error('An error occurred while removing the item.');
    }
  });
}



  addtocart(id : any , sellerId: any){
    const param = {
      product_id :id,
      size: "Small",
      seller_id: sellerId, // Include seller_id in the payload
      quantity: 1
    }


this.api.addToCart(param).then((res: any)=>{
      if(res.message.status !== 302){
        this.toastr.success(res.message);
      }else{
        this.toastr.error(res.message); 
        this.router.navigate(["/Signin"]);
      }
    },)
  }
  }